import { useState } from "react";
import { Button, IconProvider } from "../ui";

interface SubscribeStep4Props {
  onNext: (selectedOptions: string[]) => void;
}

const SubscribeStep4: React.FC<SubscribeStep4Props> = ({  onNext }) => {
  const [currentState, setCurrentState] = useState<string[]>([]);
  const selectOptions = [
    { label: "In Idea Phase", value: "in-idea-phase" }, 
    { label: "In Development", value: "in-development" },
    { label: "In Production", value: "in-production" },
    { label: "In Testing", value: "in-testing" },
  ];
  

  const handleOptionToggle = (value: string) => {
    setCurrentState((prev) =>
      prev.includes(value)
        ? prev.filter((option) => option !== value)
        : [...prev, value]
    );
  };


  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onNext(currentState);
  };

  return (
    <>
 <h2 className="text-xl font-bold text-left text-gray-900 ">
        What is the current status of your project?
      </h2>
      <p className="text-sm text-gray-900 pb-4">
        (You can select multiple options if you have multiple projects)
      </p>
      <div className="flex flex-col gap-6 w-full">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {selectOptions.map((option) => (
            <Button
              key={option.value}
              variant="toggleCheck"
              isChecked={currentState.includes(option.value)}
              onToggle={() => handleOptionToggle(option.value)}
              className="h-12 text-sm"
            >
              {option.label}
            </Button>
          ))}
        </div>
       
        <div className="flex justify-center mt-4">
          <Button
            variant="default"
            onClick={handleSubmit}
            className="w-full "
            disabled={currentState.length === 0}
          >
            Continue
          </Button>
        </div>
      </div>
    </>
  );
};
export default SubscribeStep4;
